import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouteObject,
  RouterProvider,
} from 'react-router-dom';
import ProtectedRoute from '@auth/ProtectedRoute';
import { AppContextProvider } from './AppContext';
import { AuthContextProvider } from '@auth/AuthContext';
import TabView from '../tab/TabView';
import { Home } from '@components/home';
import { ThemeContextProvider } from '@theme/ThemeContext';
import App from './App';
import { CustomerError } from '../tab/customerError';

const createAppRoute = (basePath: string) =>
  ({
    path: basePath,
    element: (
      <ProtectedRoute redirectPath="/error">
        <TabView />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '*',
        element: <Navigate to="" replace />,
      },
      {
        index: true,
        element: <Home />,
      },
    ],
  }) satisfies RouteObject;

const router = createBrowserRouter([
  {
    element: (
      <AppContextProvider>
        <AuthContextProvider>
          <ThemeContextProvider>
            <App>
              <Outlet />
            </App>
          </ThemeContextProvider>
        </AuthContextProvider>
      </AppContextProvider>
    ),
    children: [
      createAppRoute('tab'),
      createAppRoute('demo'),
      {
        path: 'error',
        element: <CustomerError />,
      },
      {
        path: '*',
        element: <Navigate to="tab" replace />,
      },
    ],
  },
]);

export const AppRouter = () => {
  return <RouterProvider router={router} />;
};
